import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { useAppDispatch } from '../../../../support/store';
import { addJourneyMapDraftFirstItem } from '../../../../support/slices/journeyMapBuilderSlice';

export default function JourneyMapCanvasStartNode() {
  const dispatch = useAppDispatch();

  return (
    <Paper
      elevation={1}
      onClick={(e) => {
        e.stopPropagation();
        dispatch(addJourneyMapDraftFirstItem({ kind: 'content' }));
      }}
      sx={{
        px: 3,
        py: 2,
        borderRadius: 3,
        border: '2px dashed #1D69CC',
        background: '#EAF3FF',
        minWidth: 260,
        textAlign: 'center',
        cursor: 'pointer',
      }}
    >
      <Box sx={{ display: 'grid', placeItems: 'center', gap: 1 }}>
        <AccountTreeIcon sx={{ color: '#1D69CC' }} />
        <Typography variant="body1" sx={{ fontWeight: 700, color: '#23282E' }}>
          + Add first item
        </Typography>
      </Box>
    </Paper>
  );
}